import { useState, useEffect } from "react";
import { ConspostratamientoCreate } from "./ConspostratamientoCreate";
import { useLoaderData, useParams } from "react-router-dom";

import * as APIUSER from "../services/user";

// import { DefaultEditor } from "react-simple-wysiwyg";

export function ConspostratamientoNew(props) {
  const conspostratamiento = useLoaderData();

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);

  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  // Set number of sesion based on number of items published
  let conspostratamientoLength = conspostratamiento.length;
  let currentSesion = conspostratamientoLength + 1;

  const [conspostResp, setConspostResp] = useState(props.especialistaFullName);
  const [metaFecha, setConspostFecha] = useState(todayDate);
  const [conspostMedio, setConspostMedio] = useState("");
  const [conspostTipo, setConspostTipo] = useState("");
  const [conspostObs, setConspostObs] = useState("");
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();

  const [value, setValue] = useState("");


  function onChange(e) {
    setValue(e.target.value);
  }

  console.log(currentSesion);

  const submitConspostratamiento = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      conspostResp,
      metaFecha,
      conspostMedio,
      conspostTipo,
      conspostObs,
      tratamientoId,
      pacienteId
    );
    try {
      await ConspostratamientoCreate(
        conspostResp,
        metaFecha,
        conspostMedio,
        conspostTipo,
        conspostObs,
        tratamientoId,
        pacienteId
      ).then(
        (val) => {
          window.location.replace(`../consulta-post-tratamiento/${val.id}`);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        <form id='formNewElement' onSubmit={submitConspostratamiento}>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='conspostResp'>Responsable</label>
              <div className='control'>
                <input
                  className='input'
                  id='conspostResp'
                  required
                  type='text'
                  value={conspostResp}
                  onChange={(e) => setConspostResp(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='metaFecha'>Fecha visita</label>
              <div className='control'>
                <input
                  className='input'
                  id='metaFecha'
                  required
                  type='date'
                  value={metaFecha}
                  onChange={(e) => setConspostFecha(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='conspostMedio'>Medio</label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='conspostMedio'
                    required
                    name='conspostMedio'
                    defaultValue=''
                    onChange={(e) => setConspostMedio(e.target.value)}
                  >
                    <option disabled value=''>
                      -- Selecciona una opción --
                    </option>
                    <option value='presencial'>Presencial</option>
                    <option value='videoconferencia'>Videoconferencia</option>
                    <option value='telefonico'>Telefónico</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='field'>
              <label htmlFor='conspostTipo'>Tipo</label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='conspostTipo'
                    required
                    name='conspostTipo'
                    value={conspostTipo}
                    onChange={(e) => setConspostTipo(e.target.value)}
                  >
                    {( props.userRole.includes('administrador')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='medica'>Médica</option>
                      <option value='psicologica'>Psicológica</option>
                      <option value='psiquiatrica'>Psiquiátrica</option>
                      <option value='ypsilon'>Ypsilon ambulatorio</option>
                    </>
                    : ( props.userRole.includes('medicina')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='medica'>Médica</option>
                    </>
                    : ( props.userRole.includes('psicologia-hospital') || props.userRole.includes('psicologia')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='psicologica'>Psicológica</option>
                      <option value='psiquiatrica'>Psiquiátrica</option>
                      <option value='ypsilon'>Ypsilon ambulatorio</option>
                    </>
                    :
                      <option disabled value=''>Sin Permisos</option>
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className='field'>
            <label htmlFor='conspostObs'>Observaciones</label>
            <div className='control'>
              <textarea
                className='textarea'
                name='conspostObs'
                id='conspostObs'
                value={conspostObs}
                onChange={(e) => setConspostObs(e.target.value)}
              ></textarea>
            </div>
          </div>
        </form>
      </div>
      <div id='actions'>
      {(props.userRole.includes('administrador') || props.userRole.includes('psicologia') || props.userRole.includes('medicina')) && (
        <button 
        className='button is-link' 
        form='formNewElement' 
        type='submit'
        disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
      )}
      </div>
    </>
  );
}
